import { createTheme, responsiveFontSizes } from "@mui/material";
import { grey } from "@mui/material/colors";

const theme = createTheme({
    palette: {
        mode: 'dark'
    },
    components: {
        MuiGrid: {
            defaultProps: {
                spacing: 3
            }
        },
        MuiStack: {
            defaultProps: {
                spacing: 3
            }
        },
        MuiTextField: {
            defaultProps: {
                variant: 'filled'
            }
        },
    },
    typography: {
        h1: {
            alignItems: 'center',
            display: 'flex',
            fontFamily: [ '"Special Elite"', 'sans-serif' ].join( ','),
            gap: 8,
            fontSize: '25px'
        },
        h2: {
            fontSize: '20px'
        },
        caption: {
            color: grey[ 500 ],
            fontSize: '10px'
        },
        bigboy: {
            fontFamily: [ '"Special Elite"', 'sans-serif' ].join( ','),
            fontSize: '80px',
            '@media (max-width:768px)': {
                fontSize: '20px',
            },
        },
        largeboy: {
            fontFamily: [ '"Special Elite"', 'sans-serif' ].join( ','),
            fontSize: '60px'
        }
    }

});

export default responsiveFontSizes( theme );